import React from 'react';
import '../styles/ProductCard.css';

function ProductCard({ product, viewMode, onDelete, onEdit, onWhatsApp, onToggleVendido }) {
  const priceDiscount = product.precoWeb && product.meuPreco < product.precoWeb;
  const discountPercent = priceDiscount
    ? Math.round(((product.precoWeb - product.meuPreco) / product.precoWeb) * 100)
    : 0;

  const vendido = !!product.vendido;
  const qty = parseInt(product.quantidade) || 0;
  // Label do botão de venda considera o estoque
  const labelVendidoList = vendido ? '↩ Disponível' : qty > 1 ? `−1 Vendida (${qty} em estoque)` : '✔ Vendido';
  const labelVendidoGrid = vendido ? '↩' : qty > 1 ? '−1' : '✔';
  const titleVendido = vendido ? 'Marcar como disponível' : qty > 1 ? `Registrar 1 venda (restam ${qty - 1})` : 'Marcar como vendido';

  if (viewMode === 'list') {
    return (
      <div className={`product-card product-list-item${vendido ? ' vendido' : ''}`}>
        <div className="product-image-container">
          {(product.imagens && product.imagens[0]) || product.imagem ? (
            <img src={(product.imagens && product.imagens[0]) || product.imagem} alt={product.titulo} className="product-image" />
          ) : (
            <div className="product-image-placeholder">
              <span>📷</span>
            </div>
          )}
          {vendido && <div className="vendido-overlay">VENDIDO</div>}
          {!vendido && priceDiscount && (
            <div className="discount-badge">{discountPercent}% OFF</div>
          )}
        </div>

        <div className="product-info-list">
          <div className="product-header">
            <h3 className="product-title">{product.titulo}</h3>
          </div>

          {product.descricao && (
            <p className="product-description">{product.descricao}</p>
          )}

          <div className="product-specs">
            {(product.altura || product.largura || product.comprimento) && (
              <span className="spec-item">
                📐 {[product.altura && `${product.altura}cm`, product.largura && `${product.largura}cm`, product.comprimento && `${product.comprimento}cm`].filter(Boolean).join(' x ')}
              </span>
            )}
            {product.peso && (
              <span className="spec-item">⚖️ {product.peso}g</span>
            )}
            {product.quantidade !== undefined && product.quantidade !== '' && (
              <span className="spec-item">📦 Estoque: {product.quantidade}</span>
            )}
          </div>

          <div className="product-prices">
            {product.precoWeb && product.precoWeb !== '0' && (
              <span className="price-web">R$ {parseFloat(product.precoWeb).toFixed(2)}</span>
            )}
            <span className="price-main">R$ {parseFloat(product.meuPreco).toFixed(2)}</span>
          </div>

          <div className="product-actions">
            {!vendido && (
              <button className="btn btn-whatsapp" onClick={onWhatsApp}>
                💬 WhatsApp
              </button>
            )}
            <button className={`btn btn-vendido${vendido ? ' ativo' : ''}`} onClick={onToggleVendido}>
              {labelVendidoList}
            </button>
            <button className="btn btn-edit" onClick={onEdit}>
              ✎ Editar
            </button>
            <button className="btn btn-delete" onClick={onDelete}>
              🗑️ Excluir
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`product-card product-grid-item${vendido ? ' vendido' : ''}`}>
      <div className="product-image-wrapper">
        {(product.imagens && product.imagens[0]) || product.imagem ? (
          <img src={(product.imagens && product.imagens[0]) || product.imagem} alt={product.titulo} className="product-image" />
        ) : (
          <div className="product-image-placeholder">
            <span>📷</span>
          </div>
        )}
        {vendido && <div className="vendido-overlay">VENDIDO</div>}
        {!vendido && priceDiscount && (
          <div className="discount-badge">{discountPercent}% OFF</div>
        )}
      </div>

      <div className="product-content">
        <h3 className="product-title">{product.titulo}</h3>

        {(product.altura || product.largura || product.comprimento) && (
          <p className="product-meta">
            📐 {[product.altura && `${product.altura}cm`, product.largura && `${product.largura}cm`, product.comprimento && `${product.comprimento}cm`].filter(Boolean).join(' x ')}
          </p>
        )}

        {product.peso && (
          <p className="product-meta">⚖️ {product.peso}g</p>
        )}
        {product.quantidade !== undefined && product.quantidade !== '' && (
          <p className="product-meta">📦 Estoque: {product.quantidade}</p>
        )}

        {product.descricao && (
          <p className="product-description-short">
            {product.descricao.substring(0, 80)}
            {product.descricao.length > 80 ? '...' : ''}
          </p>
        )}

        <div className="product-prices">
          {product.precoWeb && product.precoWeb !== '0' && (
            <span className="price-web">R$ {parseFloat(product.precoWeb).toFixed(2)}</span>
          )}
          <span className="price-main">R$ {parseFloat(product.meuPreco).toFixed(2)}</span>
        </div>

        <div className="product-buttons">
          {!vendido && (
            <button className="btn btn-whatsapp-large" onClick={onWhatsApp}>
              💬 WhatsApp
            </button>
          )}
          <div className="btn-group">
            <button className={`btn btn-small btn-vendido${vendido ? ' ativo' : ''}`} onClick={onToggleVendido} title={titleVendido}>
              {labelVendidoGrid}
            </button>
            <button className="btn btn-small btn-edit" onClick={onEdit}>
              ✎
            </button>
            <button className="btn btn-small btn-delete" onClick={onDelete}>
              🗑️
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
